import {authHeader, handleResponsePublic as handleResponse} from '../_helpers';

export const courseService = {
  register,
  getAll,
  getById,
  update,
  enroll,
  delete: _delete
};

function getAll(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store',
  };

  return fetch(`${process.env.REACT_APP_API_URL}/courses${api_params}`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store',
  };

  return fetch(`${process.env.REACT_APP_API_URL}/courses/${id}`, requestOptions).then(handleResponse);
}

function register(course) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(course),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/courses`, requestOptions).then(handleResponse);
}

function update(course) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(course),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/courses/${course.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    cache: 'no-store',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/courses/${id}`, requestOptions).then(handleResponse);
}



function enroll(slug) {
  const requestOptions = {
    method: 'GET',
    cache: 'no-store',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/course_enroll/${slug}`, requestOptions).then(handleResponse);
}
